var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormTracksAndTornadoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9467 5.44361C27.8114 5.44361 31.0065 8.31095 31.5287 12.0344C34.4911 12.1424 36.8549 14.5728 36.8549 17.5618C36.8548 20.6195 34.3805 23.094 31.3227 23.094H17.8207L17.8061 23.093C14.1634 22.9719 11.2495 19.9764 11.2495 16.3059C11.2495 12.8561 13.8166 10.0184 17.142 9.57838C18.4176 7.12028 20.9803 5.44368 23.9467 5.44361Z",
    fill: "#1C53EC",
    stroke: "white",
    strokeWidth: 1.75624,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9828 20.6248C22.9828 17.4988 18.5073 14.9683 12.9799 14.9683C7.46243 14.9584 2.97699 17.4988 2.97699 20.6248C2.97699 21.2996 3.19531 21.9545 3.59225 22.5598L9.74485 33.317C10.1517 34.0315 10.7372 34.6566 11.4715 35.0238C11.5807 35.0734 11.6899 35.133 11.8089 35.1727C12.1662 35.3215 12.5135 35.4009 12.841 35.4108C12.8906 35.4108 12.9501 35.4108 13.0097 35.4108C13.0692 35.4108 13.1188 35.4108 13.1784 35.4108C13.5059 35.4009 13.8532 35.3215 14.2104 35.1727C14.3295 35.123 14.4387 35.0734 14.5478 35.0238C15.2822 34.6566 15.8577 34.0315 16.2745 33.317L22.3874 22.5598C22.7645 21.9545 22.9828 21.2996 22.9828 20.6248Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.19489,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.98 25.8054C17.5563 25.8054 21.2661 23.7261 21.2661 21.1612C21.2661 18.5962 17.5563 16.5169 12.98 16.5169C8.40367 16.5169 4.69383 18.5962 4.69383 21.1612C4.69383 23.7261 8.40367 25.8054 12.98 25.8054Z",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 26.2221C18.1601 27.5816 15.8082 28.6037 12.98 28.6037C9.79452 28.6037 7.2144 27.3038 7.2144 25.6961C7.2144 24.0885 9.79452 22.7886 12.98 22.7886C14.667 22.7886 16.1754 23.1557 17.2372 23.7313",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8997 29.5963C16.2349 30.6184 14.7265 31.3329 12.97 31.3329C11.67 31.3329 10.499 30.9359 9.71509 30.3207",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84515 23.5231C6.33141 21.2705 9.29855 19.5338 12.8909 19.5338C15.6992 19.5338 18.1305 20.5957 19.2816 22.1338",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19969 22.7488L10.3004 31.5609C10.6378 32.1464 11.124 32.6525 11.7294 32.9601C12.3843 33.2876 13.2775 33.486 14.2301 32.9799",
    stroke: "#1C53EC",
    strokeWidth: 1.27272,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7333 19.6702C28.1696 19.2087 28.867 19.0755 29.4482 19.3674L29.5634 19.4319L29.6865 19.5169C30.2726 19.9685 30.434 20.8007 30.0351 21.4436L28.0663 24.6165H30.6982C31.1787 24.6167 31.6222 24.8536 31.8925 25.2385L31.998 25.4124L32.0771 25.5999C32.2313 26.0446 32.1632 26.543 31.8818 26.9329L28.2216 32.0042C27.75 32.6576 26.8375 32.8053 26.1835 32.3342H26.1826C25.5296 31.8628 25.381 30.9505 25.8525 30.2962V30.2952L27.8437 27.5374H25.4394C24.9097 27.5373 24.4208 27.2507 24.163 26.7874V26.7864C23.9067 26.3245 23.9194 25.7591 24.1982 25.3088V25.3079L27.5536 19.9026L27.6015 19.8342L27.6835 19.7288C27.6992 19.7086 27.7158 19.6888 27.7333 19.6702Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7944 20.7268L25.4399 26.1314H30.698L27.0373 31.2031",
    stroke: "#1C53EC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormTracksAndTornadoes);
export default __webpack_public_path__ + "static/media/storm-tracks-and-tornadoes.0738d5702b4195a9b7af827c2323f526.svg";
export { ForwardRef as ReactComponent };